"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _dataMap = _interopRequireDefault(require("../data-map"));

var _seriesDataValue = _interopRequireDefault(require("../series-data-value"));

/**
 * A class to represent a single series of data
 * @param {object} options - See below
 * @param {string} options.name - The name for the series
 * @param {object[]} data - An array of objects that represent the points. Should either be formatted as { key: {string}, value: {number} } or a dataMap should be provided
 * @param {DataMap} [dataMap] - A data map to shape the data into a known shape
 *
 * @property {string} name - The name of the series
 * @property {Array<object>} data - The data
 */
var SeriesData = function SeriesData(options) {
  (0, _classCallCheck2.default)(this, SeriesData);

  if (!options || (0, _typeof2.default)(options) !== 'object') {
    throw new TypeError("options must be an object. Value Provided: ".concat(options));
  }

  if (!options.name || typeof options.name !== 'string') {
    throw new TypeError("options.name must be a non empty string. Provided value: ".concat(options.name));
  }

  if (!options.data || !Array.isArray(options.data) || !options.data.every(function (point) {
    return point && (0, _typeof2.default)(point) === 'object';
  })) {
    throw new TypeError("options.data must be an array of objects. Provided value: ".concat(options.data));
  }

  var safeDataMap = options.dataMap;

  if (!safeDataMap) {
    safeDataMap = new _dataMap.default();
  } else {
    safeDataMap = new _dataMap.default(options.dataMap);
  }

  this.name = options.name;
  this.data = mapData(options.data, safeDataMap);
  Object.freeze(this);
};

function mapData(data, dataMap) {
  var finalArray = [];
  var keys = {};
  data.forEach(function (item) {
    if (item[dataMap.valuePropertyName] !== 0 && !item[dataMap.valuePropertyName]) {
      throw new Error("Error mapping data! An item did not contain a mapping for valuePropertyName(\"".concat(dataMap.valuePropertyName, "\"). Current item: ").concat(item));
    }

    if (!item[dataMap.keyPropertyName]) {
      throw new Error("Error mapping data! An item did not contain a mapping for keyPropertyName(\"".concat(dataMap.keyPropertyName, "\"). Current item: ").concat(item));
    }

    var value = item[dataMap.valuePropertyName];

    if (!_seriesDataValue.default.isValidSeriesDataValue(value)) {
      throw new TypeError("Series data contains invalid value. Values must be numeric or \"NO_DATA\". Provided value: ".concat(value));
    }

    var key = item[dataMap.keyPropertyName];

    if (keys[key]) {
      throw new Error("Error mapping data! More than one item uses the same key. Duplicate key: ".concat(key));
    }

    keys[key] = true;
    finalArray.push({
      key: key,
      value: value
    });
  });
  return finalArray;
}
/**
 * @module seriesData
 */


var _default = SeriesData;
exports.default = _default;